<template>
  <div class="contentDetails activityDrawFirst">
    <NavBar :navBlock="navBlock" :navtitle="navtitle" :pageBack="true"></NavBar>
    <div class="detailsContent">
      <div class="detailsTitle" v-if="status == 2">
        <div class="detailsWrap"></div>
        <p>活動報名未結束，僅支持下載報名資料</p>
      </div>
      <div class="detailsTitle" v-else>
        <div class="detailsWrap"></div>
        <p>活動抽籤</p>
      </div>

      <el-form>
        <el-form-item label="活動名稱 ：">
          <div class="activityRowRight" style="width: 80%;">
            {{ drawDetail.applyName }}
          </div>
        </el-form-item>
        <el-form-item label="活動類型 ：">
          <div class="activityRowRight">
            {{
              drawDetail.applyWay == "1"
                ? "一般活動"
                : drawDetail.applyWay == "2"
                ? "演唱會"
                : drawDetail.applyWay == "4"
                ? "見面會"
                : drawDetail.applyWay == "3"
                ? "後臺活動"
                : ""
            }}
          </div>
        </el-form-item>
        <el-form-item label="收費活動 ：" v-if="status != 2">
          <div class="activityRowRight">
            <!-- 印记 -->
            {{ drawDetail.free == 0 ? "否" : "是" }}
          </div>
        </el-form-item>
        <el-form-item
          label="活動場地 ："
          v-if="drawDetail.free == 1 && status != 2"
        >
          <div class="activityRowRight">
            <!-- 印记 -->
            {{ drawDetail.land == 0 ? "大陆" : "非大陆" }}
          </div>
        </el-form-item>
        <el-form-item
          label="收费金额 ："
          v-if="drawDetail.free == 1 && status != 2"
        >
          <div class="activityRowRight">
            <!-- 印记 -->
            {{ drawDetail.price + "CNY" }}
          </div>
          <div class="activityRowRight">
            <!-- 印记 -->
            {{ drawDetail.twdPrice + "TWD" }}
          </div>
        </el-form-item>
        <el-form-item label="登記人數 ：">
          <div class="activityRowRight">
            {{ drawDetail.registration }}
            <span @click="getDrawDetail" class="refresh">刷新</span>
          </div>
        </el-form-item>
        <el-form-item label="已抽選人數 ：" v-if="status != 2">
          <div class="activityRowRight">
            {{ drawDetail.selectionNumber }}
          </div>
        </el-form-item>
        <el-form-item label="是否進行電腦抽選 ：" v-if="status != 2">
          <div class="activityRowRight">
            <el-switch
              active-color="#6C3DEA"
              v-model="isComputer"
              @change="activeChange"
            >
            </el-switch>
          </div>
        </el-form-item>
        <el-form-item label="表格抽取 ：" v-if="!isComputer">
          <div
            class="activityRowRight"
            style="display:flex;align-items:center;text-align:center"
          >
            <div class="btn" @click="uploadModal" v-if="status != 2">
              上傳抽取資料
            </div>
            <div class="downloadExcel" @click="showCondition">
              下載用戶報名資料
            </div>
          </div>
        </el-form-item>
        <el-form-item label="抽選條件 ：" v-else>
          <div
            class="activityRowRight"
            style="text-align:center"
            v-if="drawDetail.conditionDtoList.length === 0"
          >
            <div class="btn" @click="showCondition">
              添加條件
            </div>
          </div>
          <div class="activityRowRight eltable" v-else>
            <el-table
              stripe
              :data="drawDetail.conditionDtoList"
              style="width:100%;"
              row-key="id"
            >
              <template slot="empty">
                <div class="no-data-container">
                  <img
                    src="@/assets/images/common/no_data.png"
                    alt="暂无数据"
                    :style="{ width: '244px', height: '139px' }"
                  />
                </div>
              </template>
              <el-table-column
                v-for="(item, index) in conditionDtoListTable"
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :width="item.width"
              >
                <template slot-scope="scope">
                  <div
                    v-if="scope.row[item.prop] != 0 && !scope.row[item.prop]"
                  >
                    -
                  </div>
                  <div
                    v-else-if="item.prop == 'peopleNumber'"
                    style="color: #6C3DEA"
                  >
                    {{
                      scope.row[item.prop] == 0
                        ? "暫無符合條件"
                        : "已抽選" + scope.row[item.prop] + "人"
                    }}
                  </div>
                  <div v-else>{{ scope.row[item.prop] }}</div>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="185">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    v-if="
                      scope.$index + 1 == drawDetail.conditionDtoList.length
                    "
                    @click="deleteCondition(scope.row.id)"
                    >删除</el-button
                  >
                  <el-button
                    type="text"
                    @click="detailShow(scope.row.id)"
                    :disabled="scope.row.peopleNumber == 0"
                    :key="scope.row.id"
                    >查看詳情</el-button
                  >
                  <el-button
                    type="text"
                    v-if="
                      scope.$index + 1 == drawDetail.conditionDtoList.length
                    "
                    @click="redraw(scope.row.id)"
                    >重新抽選</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="btngroup" style="justify-content:flex-end">
              <div
                class="btn borderBtn"
                @click="resetlist"
                style="margin-right:28px"
              >
                重置
              </div>
              <div class="btn" @click="showCondition">
                添加條件
              </div>
            </div>
            <div class="btngroup" style="margin-top:68px">
              <div class="btn" @click="gengratelist" style="text-align:center">
                生成抽選列表
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <!-- 抽签条件 -->
      <el-dialog
        title="添加條件"
        :visible.sync="conditionModal"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="700px"
      >
        <div class="dialog">
          <div>
            <el-checkbox-group v-model="checkList">
              <div class="dialogrow" v-if="isComputer">
                <el-checkbox
                  label="抽籤人數"
                  :disabled="conditionObj.drawPeople === '' ? true : false"
                ></el-checkbox>
                <el-input
                  v-model="conditionObj.drawPeople"
                  placeholder="請輸入抽籤人數"
                  type="text"
                  maxlength="18"
                  @input="numberonly($event, 'drawPeople')"
                ></el-input>
              </div>
              <div class="dialogrow">
                <el-checkbox
                  label="地區"
                  :disabled="conditionObj.selectArea === '' ? true : false"
                ></el-checkbox>
                <el-select
                  v-model="conditionObj.selectArea"
                  placeholder="请选择地區"
                  @change="selectAreaChange"
                >
                  <el-option
                    v-for="item in Areaoptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <div
                  style="margin-left:10px;margin-right:10px;color:#606266;font-weight:500;font-size:14px;width:76px"
                >
                  詳細地區
                </div>
                <el-input
                  v-model="conditionObj.areaDetail"
                  placeholder="請輸入詳細地址，如上海"
                  @input="focusOn('area', $event)"
                ></el-input>
              </div>
              <div class="dialogrow">
                <el-checkbox
                  label="VIP开始时间早于"
                  :disabled="conditionObj.startTime ? false : true"
                ></el-checkbox>
                <el-date-picker
                  v-model="conditionObj.startTime"
                  type="datetime"
                  placeholder="開始時間"
                  @focus="focusOn('start')"
                ></el-date-picker>
                <!-- <div
                  style="margin-left:10px;margin-right:10px;color:#606266;font-weight:500;font-size:14px;width:76px"
                >
                  至
                </div> -->
                <!-- <el-date-picker
                  v-model="conditionObj.endTime"
                  type="datetime"
                  placeholder="結束時間"
                ></el-date-picker> -->
              </div>
              <div class="dialogrow">
                <el-checkbox
                  label="VIP结束时间晚于"
                  :disabled="conditionObj.endTime ? false : true"
                ></el-checkbox>
                <el-date-picker
                  v-model="conditionObj.endTime"
                  type="datetime"
                  placeholder="結束時間"
                  @focus="focusOn('end')"
                ></el-date-picker>
              </div>
              <div class="dialogrow">
                <el-checkbox
                  label="本年度中选次数"
                  :disabled="
                    conditionObj.chooseMin && conditionObj.chooseMax
                      ? false
                      : true
                  "
                ></el-checkbox>
                <el-input
                  v-model="conditionObj.chooseMin"
                  placeholder="請輸入数字"
                  type="text"
                  @input="numberonly($event, 'chooseMin')"
                ></el-input>
                <div
                  style="margin-left:10px;margin-right:10px;color:#606266;font-weight:500;font-size:14px;width:76px"
                >
                  ~
                </div>
                <el-input
                  v-model="conditionObj.chooseMax"
                  placeholder="請輸入数字"
                  type="text"
                  @input="numberonly($event, 'chooseMax')"
                ></el-input>
              </div>
              <div class="dialogrow">
                <el-checkbox
                  label="同类型中选次数"
                  :disabled="
                    conditionObj.chooseComMin && conditionObj.chooseComMax
                      ? false
                      : true
                  "
                ></el-checkbox>
                <el-input
                  v-model="conditionObj.chooseComMin"
                  placeholder="請輸入数字"
                  type="text"
                  @input="numberonly($event, 'chooseComMin')"
                ></el-input>
                <div
                  style="margin-left:10px;margin-right:10px;color:#606266;font-weight:500;font-size:14px;width:76px"
                >
                  ~
                </div>
                <el-input
                  v-model="conditionObj.chooseComMax"
                  placeholder="請輸入数字"
                  type="text"
                  @input="numberonly($event, 'chooseComMax')"
                ></el-input>
              </div>
              <div class="dialogrow">
                <el-checkbox label="排除黑名單"></el-checkbox>
                <el-switch
                  active-color="#6C3DEA"
                  v-model="conditionObj.isblack"
                >
                </el-switch>
                <!-- <el-select v-model="conditionObj.isblack" placeholder="請選擇是否為黑名單">
                                <el-option label="是" value="2"></el-option>
                                <el-option label="否" value="1"></el-option>
                            </el-select> -->
              </div>
              <div
                class="dialogrow"
                v-for="(item, index) in conditionObj.badgeSelectList"
                :key="index"
              >
                <el-checkbox
                  label="徽章"
                  v-if="index == 0"
                  :disabled="
                    conditionObj.badgeSelectList[0].badgeType === '' ||
                    conditionObj.badgeSelectList[0].badgeLevel === ''
                      ? true
                      : false
                  "
                ></el-checkbox>
                <div v-else style="width:150px;"></div>
                <el-select
                  v-model="conditionObj.badgeSelectList[index].badgeType"
                  placeholder="請選擇徽章"
                  @change="BadgeoptionsChange(index, item)"
                >
                  <el-option
                    v-for="item in Badgeoptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-select
                  v-model="conditionObj.badgeSelectList[index].badgeLevel"
                  placeholder="請選擇徽章等級"
                  style="margin-left:10px"
                >
                  <el-option
                    v-for="item in conditionObj.badgeSelectList[index]
                      .BadgeLeveloptions"
                    :key="item.id"
                    :label="item.grade"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <div class="badgeadd" @click="badgeadd" v-if="index == 0">
                  添加
                </div>
                <div class="badgedelete" @click="badgedelete(index)" v-else>
                  删除
                </div>
              </div>
            </el-checkbox-group>

            <div class="btngroup">
              <div
                class="btn borderBtn"
                style="marginRight:63px"
                @click="reset"
              >
                重置
              </div>
              <div class="btn" @click="commitDraw">
                {{ isComputer ? "確定抽籤" : "下載抽選表格" }}
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
      <!-- 上传弹窗 -->
      <el-dialog
        title="上傳抽取資料"
        :visible.sync="uoloadModal"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="500px"
        center
      >
        <div class="dialog">
          <div>
            <el-upload
              ref="excelUpload"
              :action="this.$GLOBAL.activityPostUrl"
              :with-credentials="true"
              class="upload-demo"
              :headers="{ Authorization: this.$cookie.get('auth') }"
              drag
              :accept="'.xlsx,.xls'"
              :multiple="false"
              :file-list="fileList"
              :on-change="fileChange"
              :on-success="successExcel"
              :on-error="errorExcel"
              :auto-upload="false"
              :data="{
                applyId: this.$route.query.id
              }"
            >
              <img
                src="@/assets/images/common/blacklist_upload.png"
                alt="暂无数据"
                :style="{
                  width: '41px',
                  height: '41px',
                  marginTop: '40px',
                  marginBottom: '14px'
                }"
              />
              <div class="el-upload__text">
                將文件拖到此處，或<em>點擊上傳</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                只能上傳單個xlsx/xls文件，上傳後會跳轉到活動抽籤確認更新頁面
              </div>
            </el-upload>
            <div class="btngroup">
              <div
                class="btn borderBtn"
                style="marginRight:112px"
                @click="uoloadModal = false"
              >
                取消
              </div>
              <div class="btn" @click="submitupdate">生成抽選列表</div>
            </div>
          </div>
        </div>
      </el-dialog>
      <!-- 查看详情 -->
      <el-dialog
        title="查看已抽選詳情"
        :visible.sync="detailModal"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="850px"
      >
        <div class="dialog" style="display:block;">
          <el-table stripe :data="conditionDetailList" height="400">
            <template slot="empty">
              <div class="no-data-container">
                <img
                  src="@/assets/images/common/no_data.png"
                  alt="暂无数据"
                  :style="{ width: '244px', height: '139px' }"
                />
              </div>
            </template>
            <el-table-column
              v-for="(item, index) in conditionDetailTable"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
            >
              <template slot-scope="scope">
                <div v-if="!scope.row[item.prop]">-</div>
                <div v-else>{{ scope.row[item.prop] }}</div>
              </template>
            </el-table-column>
          </el-table>
          <div class="paging-block clearfix">
            <el-pagination
              class="paging fr"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              @size-change="handleSizeChange"
              :page-sizes="[20, 50, 100, 200]"
              :page-size="currentPageSize"
              :pager-count="5"
              layout="sizes, prev, pager, next, jumper "
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </el-dialog>

      <DiaMess v-if="dialogVisible"></DiaMess>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";
import { Indicator } from "mint-ui";
export default {
  components: {
    NavBar,
    DiaMess
  },
  data() {
    return {
      navBlock: "活動  /  活動列表",
      navtitle: "抽签",
      //回显，传参用
      drawDetail: {
        conditionDtoList: [] //条件列表
      },
      //记录页面第一次进来时的初始值
      initDrawDetail: {},
      isComputer: this.$route.query.selectionType == 1, //是否进行电脑抽选
      uoloadModal: false, //上传文件弹窗
      fileList: [],
      status: this.$route.query.status,
      dialogVisible: false,
      conditionModal: false, //选择条件弹窗
      checkList: ["排除黑名單"], //多选框
      detailModal: false,
      conditionObj: {
        drawPeople: "",
        selectArea: "",
        areaDetail: "",
        startTime: "",
        endTime: "",
        chooseMin: "", //中选次数小
        chooseMax: "", //中选次数大
        chooseComMin: "", //同类型中选次数小
        chooseComMax: "", //同类型中选次数小
        isblack: true,
        badgeSelectList: [
          {
            badgeType: "",
            badgeLevel: "",
            //徽章等级选择框,会更具选项做变化
            BadgeLeveloptions: [] //徽章等级列表
          }
        ] //徽章条件列表
      },
      currentPage: 1,
      currentPageSize: 20,
      total: 10,
      conditionDetailList: [], //抽签详情表
      conditionDetailTable: [
        {
          prop: "username",
          label: "會員帳號",
          width: ""
        },
        {
          prop: "applicant",
          label: "申請人",
          width: ""
        },
        {
          prop: "num",
          label: "張數",
          width: ""
        },
        {
          prop: "district",
          label: "地區",
          width: ""
        },
        {
          prop: "vipStartTime",
          label: "VIP起始日",
          width: ""
        },
        {
          prop: "vipEndTime",
          label: "VIP到期日",
          width: ""
        },
        {
          prop: "annualSelectNum",
          label: "本年度中選次數",
          width: ""
        },
        {
          prop: "sameTypeSelectNum",
          label: "同類型中選次數",
          width: ""
        },
        {
          prop: "remark",
          label: "報名備註",
          width: ""
        }
      ],
      //条件表
      conditionDtoListTable: [
        {
          prop: "condition",
          label: "條件",
          width: ""
        },
        {
          prop: "peopleNumber",
          label: "執行狀態",
          width: "100"
        }
      ],
      //地区选择框
      Areaoptions: [
        {
          value: "1",
          label: "中國大陸"
        },
        {
          value: "2",
          label: "港澳臺"
        },
        {
          value: "3",
          label: "海外"
        }
      ],
      //徽章选择框
      Badgeoptions: [],
      BadgeoptionsSum: [],
      detailId: "", //翻页,
      focusType: ""
    };
  },
  created() {
    this.getDrawDetail();
    //徽章处理
    this.BadgeInit();
  },
  methods: {
    //页面详情
    getDrawDetail(type) {
      let url;
      if (type == "reset") {
        url = `/request/apply/getApplyStatus?applyId=${
          this.$route.query.id
        }&status=${1}`;
      } else {
        url = `/request/apply/getApplyStatus?applyId=${this.$route.query.id}`;
      }
      this.$get(url, this.$GLOBAL.jsonConfig).then(res => {
        if (res.code == "00000") {
          this.drawDetail = res.data;
          this.conditionObj.drawPeople = res.data.registration;
          this.isComputer = res.data.selectionType == 1;
        } else {
          this.dialogVisible = true;
          this.$propMessage(res.message, "error", () => {
            this.dialogVisible = false;
          });
        }
      });
    },
    //上传文件方法
    uploadModal() {
      this.uoloadModal = true;
    },
    activeChange() {
      console.log("标识");
      this.reset();
    },
    downloadExcel() {
      let param = this.conditionParam();
      if (!param) {
        return;
      }
      let date = new Date();
      let _this = this;
      let url = `/request/apply/export/excel`;
      _this.$exportExcel(
        url,
        "POST",
        param,
        "用戶報名資料" + this.$formatDate(date).substring(0, 10)
      );
      _this.conditionModal = false;
    },
    fileChange(file, fileList) {
      this.fileList = [];
      this.fileList.push(file);
    },
    successExcel(res, file, fileList) {
      let _this = this;
      if (res.code === "00000") {
        Indicator.close();
        _this.dialogVisible = true;
        _this.$refs.excelUpload.clearFiles();
        this.uoloadModal = false;
        _this.$propMessage("報名狀態更新成功", "success", () => {
          _this.dialogVisible = false;
          _this
            .$get(
              `/request/apply/generate/selection/list?applyId=${_this.$route.query.id}`
            )
            .then(res => {
              if (res.code == "00000") {
                _this.$router.replace(
                  `/activityDrawList?id=${_this.$route.query.id}`
                );
                this.$bus.$emit("activityDrawinit");
              } else {
                _this.dialogVisible = true;
                _this.$propMessage(res.message, "error", function() {
                  _this.dialogVisible = false;
                });
              }
            });
        });
      } else {
        Indicator.close();
        _this.dialogVisible = true;
        _this.$propMessage(res.message, "error", function() {
          _this.dialogVisible = false;
          _this.$refs.excelUpload.clearFiles();
          _this.fileList = [];
        });
      }
    },
    errorExcel(err, file, fileList) {
      Indicator.close();
      let _this = this;
      _this.$refs.excelUpload.clearFiles();
      _this.dialogVisible = true;
      _this.$propMessage(err.message + ",請重新上傳", "error", function() {
        _this.dialogVisible = false;
      });
    },
    submitupdate() {
      Indicator.open("數據處理中，請耐心等待");
      this.$refs.excelUpload.submit();
    },
    //添加条件方法
    showCondition() {
      // this.checkList = []
      // this.reset()
      this.conditionModal = true;
    },
    //徽章处理
    BadgeInit() {
      this.$get("/request/badge/all", this.$GLOBAL.jsonConfig).then(res => {
        if (res.code == "00000") {
          this.BadgeoptionsSum = res.data;
          res.data.forEach(item => {
            this.Badgeoptions.push({ label: item.name, value: item.name });
          });
        } else {
          this.dialogVisible = true;
          this.$propMessage(res.message, "error", () => {
            this.dialogVisible = false;
          });
        }
      });
    },
    //重置抽签
    resetlist() {
      this.$get(
        `/request/apply/reset/screen/condition?applyId=${this.$route.query.id}`,
        this.$GLOBAL.jsonConfig
      ).then(res => {
        if (res.code == "00000") {
          this.dialogVisible = true;
          this.$propMessage("重置成功", "success", () => {
            this.getDrawDetail("reset");
            this.dialogVisible = false;
          });
        } else {
          this.dialogVisible = true;
          this.$propMessage(res.message, "error", () => {
            this.dialogVisible = false;
          });
        }
      });
    },
    //生成抽签列表
    gengratelist() {
      this.$get(
        `/request/apply/generate/selection/list?applyId=${this.$route.query.id}`,
        this.$GLOBAL.jsonConfig
      ).then(res => {
        if (res.code == "00000") {
          this.$router.replace(`/activityDrawList?id=${this.$route.query.id}`);
          this.$bus.$emit("activityDrawinit");
        }
      });
    },
    //添加徽章
    badgeadd() {
      this.conditionObj.badgeSelectList.push({
        badgeType: "",
        badgeLevel: "",
        BadgeLeveloptions: [] //徽章等级列表
      });
    },
    badgedelete(index) {
      this.conditionObj.badgeSelectList.splice(index, 1);
    },
    BadgeoptionsChange(index, item) {
      this.focusOn("list");
      let currentlist;
      this.BadgeoptionsSum.map(ite => {
        if (ite.name == item.badgeType) currentlist = ite.detailDtoList;
      });
      this.conditionObj.badgeSelectList[index].BadgeLeveloptions = currentlist;
      this.conditionObj.badgeSelectList[index].badgeLevel = "";
    },
    commitDraw() {
      if (this.isComputer) {
        this.commitMethod();
      } else {
        this.downloadExcel();
      }
    },
    commitMethod() {
      let _this = this;
      let param = this.conditionParam();
      if (!param) {
        return;
      }
      _this
        .$post(
          "/request/apply/add/screen/condition",
          param,
          this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code == "00000") {
            _this.dialogVisible = true;
            _this.conditionModal = false;
            _this.$propMessage(
              `抽籤成功，已抽選${res.data.numberPeople}人`,
              "success",
              function() {
                _this.getDrawDetail();
                _this.dialogVisible = false;
              }
            );
          } else {
            this.dialogVisible = true;
            this.$propMessage(res.message, "error", () => {
              this.dialogVisible = false;
            });
          }
        });
    },
    deleteCondition(id) {
      let _this = this;
      _this
        .$get(
          `/request/apply/delete/screen/condition?id=${id}&applyId=${_this.$route.query.id}`,
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code == "00000") {
            _this.dialogVisible = true;
            _this.$propMessage("删除成功", "success", function() {
              _this.getDrawDetail();
              _this.dialogVisible = false;
            });
          } else {
            this.dialogVisible = true;
            this.$propMessage(res.message, "error", () => {
              this.dialogVisible = false;
            });
          }
        });
    },
    detailShow(id) {
      this.detailId = id;
      this.getDetailConditionlist(id);
    },
    redraw(id) {
      this.$get(
        `/request/apply/re/screen/people?id=${id}&applyId=${this.$route.query.id}`,
        this.$GLOBAL.jsonConfig
      ).then(res => {
        if (res.code == "00000") {
          this.dialogVisible = true;
          this.$propMessage(
            `抽籤成功，已抽選${res.data.numberPeople}人`,
            "success",
            () => {
              this.dialogVisible = false;
            }
          );
        } else {
          this.dialogVisible = true;
          this.$propMessage(res.message, "error", () => {
            this.dialogVisible = false;
          });
        }
      });
    },
    getDetailConditionlist(id) {
      this.$get(
        `/request/apply/screen/detail?id=${id}&page=${this.currentPage}&size=${this.currentPageSize}`,
        this.$GLOBAL.jsonConfig
      ).then(res => {
        if (res.code == "00000") {
          this.conditionDetailList = res.data.list;
          this.total = res.data.allRow;
          this.detailModal = true;
        } else {
          this.dialogVisible = true;
          this.$propMessage(res.message, "error", () => {
            this.dialogVisible = false;
          });
        }
      });
    },
    // 分页
    handleCurrentChange(val) {
      let _this = this;
      _this.currentPage = val;
      _this.getDetailConditionlist(_this.detailId);
      // _this.getOrderList();
    },
    handleSizeChange(val) {
      let _this = this;
      _this.currentPageSize = val;
      _this.getDetailConditionlist(_this.detailId);
      // _this.getOrderList();
    },
    reset() {
      let initObj = {
        drawPeople: this.drawDetail.registration,
        selectArea: "",
        areaDetail: "",
        startTime: "",
        endTime: "",
        isblack: true,
        badgeSelectList: [
          {
            badgeType: "",
            badgeLevel: "",
            //徽章等级选择框,会更具选项做变化
            BadgeLeveloptions: [] //徽章等级列表
          }
        ] //徽章条件列表
      };
      this.conditionObj = initObj;
      if (this.isComputer) {
        this.checkList = ["抽籤人數", "排除黑名單"];
      } else {
        this.checkList = ["排除黑名單"];
      }
    },
    selectAreaChange(item) {
      this.conditionObj.areaDetail = "";
      this.focusOn("area");
    },

    numberonly(item, name) {
      this.focusOn(name);
      if (name == "drawPeople") {
        if (item.length < 2) {
          this.conditionObj[name] = item.replace(/[^1-9]/g, "");
        } else {
          this.conditionObj[name] = item.replace(/[^0-9]/g, "");
        }
      } else {
        this.conditionObj[name] = item.replace(/[^0-9]/g, "");
      }
    },
    conditionParam() {
      //校验
      let _this = this;
      console.log(_this.checkList);
      //非空人数校验
      if (this.isComputer) {
        if (!_this.checkList.includes("抽籤人數")) {
          _this.dialogVisible = true;
          _this.$propMessage("抽籤人數为必选", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        }
      }
      if (_this.checkList.includes("抽籤人數")) {
        if (
          _this.conditionObj.drawPeople === "" ||
          _this.conditionObj.drawPeople == 0
        ) {
          _this.dialogVisible = true;
          _this.$propMessage("請輸入抽籤人數", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        }
      }
      //中选次数校验
      if (_this.checkList.includes("本年度中选次数")) {
        if (_this.conditionObj.chooseMin > _this.conditionObj.chooseMax) {
          _this.dialogVisible = true;
          _this.$propMessage("本年度中选次数區間錯誤", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        }
      }
      //中选次数校验
      if (_this.checkList.includes("同类型中选次数")) {
        if (_this.conditionObj.chooseComMin > _this.conditionObj.chooseComMax) {
          _this.dialogVisible = true;
          _this.$propMessage("同类型中选次数區間錯誤", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        }
      }
      if (_this.checkList.includes("徽章")) {
        let list = _this.conditionObj.badgeSelectList.filter(
          item => item.badgeLevel != ""
        );
        let badge = [];
        list.map(item => {
          badge.push(item.badgeLevel);
        });
        const hasDuplicates = badge.length !== new Set(badge).size;
        if (hasDuplicates) {
          _this.dialogVisible = true;
          _this.$propMessage("徽章与徽章等级添加条件重复", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        }
      }
      //处理时间格式
      let startTime, endTime;
      if (
        _this.conditionObj.startTime === "" ||
        _this.conditionObj.startTime === null
      ) {
        startTime = null;
      } else {
        startTime = _this.$formatDate(_this.conditionObj.startTime);
      }
      if (
        _this.conditionObj.endTime === "" ||
        _this.conditionObj.endTime === null
      ) {
        endTime = null;
      } else {
        endTime = _this.$formatDate(_this.conditionObj.endTime);
      }
      let param = {
        applyId: _this.$route.query.id
      };
      //提交
      if (_this.checkList.includes("抽籤人數")) {
        param = {
          ...param,
          numberPeople: _this.conditionObj.drawPeople
        };
      }
      if (_this.checkList.includes("地區")) {
        param = {
          ...param,
          district: _this.conditionObj.selectArea,
          address: _this.conditionObj.areaDetail
            ? _this.conditionObj.areaDetail
            : null
        };
      }
      if (_this.checkList.includes("VIP开始时间早于")) {
        param = {
          ...param,
          vipStartTime: startTime
        };
      }
      if (_this.checkList.includes("VIP结束时间晚于")) {
        param = {
          ...param,
          vipEndTime: endTime
        };
      }
      if (_this.checkList.includes("本年度中选次数")) {
        //印记
        param = {
          ...param,
          yearSelectedNumberMin: _this.conditionObj.chooseMin,
          yearSelectedNumberMax: _this.conditionObj.chooseMax
        };
      }
      if (_this.checkList.includes("同类型中选次数")) {
        //印记
        param = {
          ...param,
          typeSelectedNumberMin: _this.conditionObj.chooseComMin,
          typeSelectedNumberMax: _this.conditionObj.chooseComMax
        };
      }
      if (_this.checkList.includes("排除黑名單")) {
        param = {
          ...param,
          blackList: _this.conditionObj.isblack ? "1" : "2"
        };
      } else {
        param = {
          ...param,
          blackList: null
        };
      }
      if (_this.checkList.includes("徽章")) {
        let badgeId = [];
        _this.conditionObj.badgeSelectList.map(item => {
          badgeId.push(item.badgeLevel);
        });
        param = {
          ...param,
          badgeId: badgeId.toString()
        };
      }
      return param;
    },
    focusOn(type) {
      console.log(type);
      this.focusType = type;
    }
  },
  watch: {
    conditionObj: {
      deep: true,
      handler(newValue, oldValue) {
        if (this.focusType == "drawPeople") {
          if (newValue.drawPeople) {
            if (!this.checkList.includes("抽籤人數"))
              this.checkList.push("抽籤人數");
          } else {
            this.checkList = this.checkList.filter(item => item !== "抽籤人數");
          }
        } else if (this.focusType == "area") {
          if (newValue.selectArea) {
            if (!this.checkList.includes("地區")) this.checkList.push("地區");
          } else {
            this.checkList = this.checkList.filter(item => item !== "地區");
          }
        } else if (this.focusType == "start") {
          if (newValue.startTime) {
            if (!this.checkList.includes("VIP开始时间早于"))
              this.checkList.push("VIP开始时间早于");
          } else {
            this.checkList = this.checkList.filter(
              item => item !== "VIP开始时间早于"
            );
          }
        } else if (this.focusType == "end") {
          if (newValue.endTime) {
            if (!this.checkList.includes("VIP结束时间晚于"))
              this.checkList.push("VIP结束时间晚于");
          } else {
            this.checkList = this.checkList.filter(
              item => item !== "VIP结束时间晚于"
            );
          }
        } else if (
          this.focusType == "chooseMin" ||
          this.focusType == "chooseMax"
        ) {
          if (newValue.chooseMin && newValue.chooseMax) {
            if (!this.checkList.includes("本年度中选次数"))
              this.checkList.push("本年度中选次数");
          } else {
            this.checkList = this.checkList.filter(
              item => item !== "本年度中选次数"
            );
          }
        } else if (
          this.focusType == "chooseComMin" ||
          this.focusType == "chooseComMax"
        ) {
          if (newValue.chooseComMin && newValue.chooseComMax) {
            if (!this.checkList.includes("同类型中选次数"))
              this.checkList.push("同类型中选次数");
          } else {
            this.checkList = this.checkList.filter(
              item => item !== "同类型中选次数"
            );
          }
        } else if (this.focusType == "list") {
          if (
            newValue.badgeSelectList[0].badgeLevel &&
            newValue.badgeSelectList[0].badgeType
          ) {
            if (!this.checkList.includes("徽章")) this.checkList.push("徽章");
          } else {
            this.checkList = this.checkList.filter(item => item !== "徽章");
          }
        }
        // if(newValue.isblack){
        //     if(!this.checkList.includes('排除黑名單'))this.checkList.push('排除黑名單')
        // }else{
        //      this.checkList= this.checkList.filter(item=>item!=='排除黑名單')
        // }
      }
    },
    isComputer(newValue, oldValue) {
      console.log(newValue);
      if (newValue) {
        if (!this.checkList.includes("抽籤人數"))
          this.checkList.push("抽籤人數");
      } else {
        this.checkList = this.checkList.filter(item => item !== "抽籤人數");
      }
    },
    uoloadModal(newValue, oldValue) {
      if (newValue === false) {
        this.fileList = [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
.refresh {
  display: inline-block;
  margin-left: 10px;
  color: #6c3dea;
  font-size: 14px;
  cursor: pointer;
}
.activityRowLeft {
  width: 300px;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  text-align: left;
}
.activityRowRight {
  font-size: 14px;
  color: #606266;
  // line-height: 40px;
}
.downloadExcel {
  margin-left: 8px;
  color: rgba(108, 61, 234, 1);
  font-size: 12px;
  cursor: pointer;
}
/deep/ .el-upload-list__item-name {
  color: black;
  .el-icon-document {
    color: black;
  }
}
/deep/ .el-table tr th {
  background: rgba(243, 243, 243, 1);
}
/deep/ .el-dialog {
  border-radius: 12px;
}
/deep/ .el-dialog__header {
  //   box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
}
/deep/ .el-dialog__title {
  font-size: 0.16rem;
}
/deep/ .el-upload__text em {
  color: #6c3dea !important;
}
/deep/ .el-upload-dragger:hover {
  border-color: #6c3dea !important;
}
/deep/ .el-upload-dragger {
  width: 320px !important;
  border: 1px dashed #d9d9d9 !important;
}
/deep/ .el-form-item {
  margin-bottom: 0.15rem;
}

.dialog {
  display: flex;
  justify-content: center;
  max-height: 80vh;
  overflow-y: auto;
  .el-upload__tip {
    color: #65676b;
  }
  .dialogrow {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    /deep/ .el-checkbox {
      width: 150px !important;
      text-align: left;
      display: block !important;
      margin-right: 0px !important;
    }
    /deep/ .el-input {
      width: 190px !important;
    }
    .badgeadd {
      width: 80px;
      color: rgba(147, 144, 163, 1);
      background: rgba(242, 240, 247, 1);
      text-align: center;
      cursor: pointer;
      line-height: 36px;
      margin-left: 9px;
      border-radius: 6px;
    }
    .badgedelete {
      width: 80px;
      text-align: center;
      color: #6c3dea;
      line-height: 36px;
      margin-left: 9px;
      cursor: pointer;
    }
  }
}
.btngroup {
  margin-top: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  .btn {
    text-align: center;
  }
}
@media screen and (max-width: 768px) {
  /deep/ .el-form-item__label {
    width: 2.6rem;
  }
  .eltable {
    width: 400px;
  }
}
.el-form .el-form-item{
  white-space:normal
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/activityDrawFirst.vue